"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const Device = __importStar(require("../../../../../../device"));
const openapi_1 = require("../../../../../openapi");
const Common = __importStar(require("../../common"));
const ExportJob = __importStar(require("../export-job"));
const Devices = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Fleet.Devices.Spec';
/*
 * `routes/v2/api/fleet/devices/router.js`: every route is
 * `AdminUserRouteGuard`. The list and export routes answer protocol v2;
 * `/consumables` still answers protocol v1.
 */
// Query structs intentionally have no identifier. Effect only emits query
// parameters when the top-level JSON Schema exposes `properties` inline.
const deviceFilters = {
    model: effect_1.Schema.optionalWith(Common.oneOrMany(Device.Class.Common.ModelCode), {
        exact: true,
    }).annotations({ description: 'Filter by device model (one code or repeated query parameter)' }),
    status: effect_1.Schema.optionalWith(Common.ConnectionStatus, { exact: true }).annotations({
        description: 'Filter by connection status',
    }),
    search: effect_1.Schema.optionalWith(effect_1.Schema.Trim.pipe(effect_1.Schema.nonEmptyString()), { exact: true }).annotations({
        description: 'Search term',
    }),
    operatingMode: effect_1.Schema.optionalWith(Common.oneOrMany(Device.Class.Base.OperatingMode), {
        exact: true,
    }).annotations({ description: 'Filter by operating mode' }),
    installationStatus: effect_1.Schema.optionalWith(Common.oneOrMany(Device.Class.Base.InstallationStatus), {
        exact: true,
    }).annotations({ description: 'Filter by installation status' }),
    businessUnit: effect_1.Schema.optionalWith(Common.oneOrMany(Common.BusinessUnitCode), {
        exact: true,
    }).annotations({ description: 'Filter by business unit code' }),
    ring: effect_1.Schema.optionalWith(Device.Class.Base.FilterableRing, { exact: true }).annotations({
        description: 'Filter by progressive-delivery ring (canary only)',
    }),
    tenantIds: effect_1.Schema.optionalWith(Common.TenantIds, { exact: true }),
    alarmTypes: effect_1.Schema.optionalWith(effect_1.Schema.ArrayEnsure(Device.Capability.Alarm.AlarmTag), {
        exact: true,
    }).annotations({ description: 'Filter by alarm types' }),
    alarmSeverities: effect_1.Schema.optionalWith(effect_1.Schema.ArrayEnsure(Device.Capability.Alarm.Severity), {
        exact: true,
    }).annotations({ description: 'Filter by alarm severities' }),
    alarmDomains: effect_1.Schema.optionalWith(effect_1.Schema.ArrayEnsure(Device.Capability.Alarm.AlarmDomain), {
        exact: true,
    }).annotations({ description: 'Filter by alarm domains' }),
};
const ListQuery = effect_1.Schema.Struct({
    ...deviceFilters,
    page: effect_1.Schema.optionalWith(Common.PositiveIntFromString, { exact: true }).annotations({
        description: 'Page number (default 1)',
    }),
    size: effect_1.Schema.optionalWith(Common.PositiveIntFromString.pipe(effect_1.Schema.lessThanOrEqualTo(100)), {
        exact: true,
    }).annotations({ description: 'Number of items per page (default 10, maximum 100)' }),
    orderBy: effect_1.Schema.optionalWith(Devices.OrderBy, { exact: true }).annotations({
        description: 'Field to order results by (default status)',
    }),
    direction: effect_1.Schema.optionalWith(Common.SortDirection, { exact: true }).annotations({
        description: 'Sort direction (default desc)',
    }),
});
const ConsumablesQuery = effect_1.Schema.Struct({
    category: effect_1.Schema.propertySignature(Common.ConsumableCategory).annotations({
        description: 'Filter by consumable category',
    }),
    model: deviceFilters.model,
    tenantIds: deviceFilters.tenantIds,
    vendor: effect_1.Schema.optionalWith(Device.Vendor.Code, { exact: true }).annotations({
        description: 'Filter by device vendor',
    }),
    search: deviceFilters.search,
    installationStatus: deviceFilters.installationStatus,
    operatingMode: deviceFilters.operatingMode,
    min: effect_1.Schema.optionalWith(Common.NonNegativeIntFromString, { exact: true }).annotations({
        description: 'Lowest fill level, percent (default 0)',
    }),
    max: effect_1.Schema.optionalWith(Common.NonNegativeIntFromString, { exact: true }).annotations({
        description: 'Highest fill level, percent (default 100). Must not be lower than min.',
    }),
    page: effect_1.Schema.optionalWith(Common.PositiveIntFromString, { exact: true }).annotations({
        description: 'Page number (default 1)',
    }),
    size: effect_1.Schema.optionalWith(Common.PositiveIntFromString.pipe(effect_1.Schema.lessThanOrEqualTo(100)), {
        exact: true,
    }).annotations({ description: 'Number of items per page (default 50, maximum 100)' }),
    orderBy: effect_1.Schema.optionalWith(Devices.ConsumablesOrderBy, { exact: true }).annotations({
        description: 'Field to order results by (default name)',
    }),
    direction: effect_1.Schema.optionalWith(Common.SortDirection, { exact: true }).annotations({
        description: 'Sort direction (default asc)',
    }),
});
const list = platform_1.HttpApiEndpoint.get('getFilteredDevices') ``
    .setUrlParams(ListQuery)
    .addSuccess(openapi_1.Response.Success(Devices.DevicePage).annotations({
    description: 'Paginated device list',
}))
    .annotate(platform_1.OpenApi.Title, 'List Fleet Devices')
    .annotate(platform_1.OpenApi.Description, 'Returns a paginated list of the devices matching the filters, scoped to the brands and tenants visible to the caller. ' +
    'Alarm filters (`alarmTypes`, `alarmSeverities`, `alarmDomains`) intersect.')
    .pipe(Common.withAdminGuard, openapi_1.Error.withLegacyV2StandardErrors);
const listConsumables = platform_1.HttpApiEndpoint.get('getFilteredDevicesWithConsumables') `/consumables`
    .setUrlParams(ConsumablesQuery)
    .addSuccess(openapi_1.Response.Success(Devices.ConsumablesDevicePage).annotations({
    description: 'Paginated devices with matching consumables',
}))
    .addError(Devices.ConsumablesValidation)
    .annotate(platform_1.OpenApi.Title, 'List Fleet Devices By Consumable Level')
    .annotate(platform_1.OpenApi.Description, 'Returns a paginated list of the devices with at least one consumable of `category` whose fill level lies between `min` and `max`, as full device documents. ' +
    'This controller answers protocol v1 bodies: 400 `Validation Error` with the decoding details, 500 `Internal Server Error`.')
    .pipe(Common.withAdminGuard, openapi_1.Error.withV1StandardErrors);
const [createExportJob, getExportJobStatus, getExportJobDownload] = ExportJob.routes('Devices', Devices.CreateExportJobBody, 'devices_export.csv');
exports.Spec = platform_1.HttpApiGroup.make('v2.fleet.devices')
    .add(list)
    .add(listConsumables)
    .add(createExportJob)
    .add(getExportJobStatus)
    .add(getExportJobDownload)
    .prefix('/fleet/devices')
    .annotate(platform_1.OpenApi.Title, 'Fleet Devices')
    .annotate(platform_1.OpenApi.Description, 'Device list of the fleet, consumable levels and CSV export jobs')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.Fleet));
//# sourceMappingURL=spec.js.map